/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/aiservices'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import EditAgentAppModal from '../../EditAgentAppModal'
import CreateModal from '../../CreateModal'
import { useNavigate, useParams } from 'react-router-dom'
import Switch from '@mui/material/Switch'
import EditAgentFunctionModal from '../../EditAgentFunctionModal'
export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [agentApps, setAgentApps] = useState([])
  const [appFunctions, setAppFunctions] = useState([])
  console.log(list, 'listlist')
  const [loader, setLoader] = useState(true)
  const navigate = useNavigate()
  const params = useParams()

  const getAppTypes = async () => {
    const { response } = await AppService.agents.get({
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }
  const getAgentApps = async () => {
    const { response } = await AppService.app_agent.getAll({
      query: `assistantId=${params.assisstant_id}`,
      toaster: false,
    })

    if (response) {
      setAgentApps(response.data)
    } else {
      setAgentApps([])
    }
    setLoader(false)
  }

  console.log('agentApps', agentApps)

  const getAgentAppFunctions = async () => {
    const { response } = await AppService.app_function.getAll({
      query: `assistantId=${params.assisstant_id}&appId=${params.app_id}`,
      toaster: false,
    })
    if (response) {
      setAppFunctions(response.data)
    } else {
      setAppFunctions([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getAppTypes()
    getAgentApps()
    getAgentAppFunctions()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.agents.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  const handleToggleActive = async (index, isActive) => {
    // Call your update API
    await AppService.app_function.update_status({
      payload: {
        assistantId: params.assisstant_id,
        appId: params.app_id,
        functionIndex: index,
        isActive: isActive, // send the full updated function
      },
    })

    // Optional: refresh functions from the backend
    getAgentAppFunctions()
  }

  const handleAppAgentDelete = async (index) => {
    agentApps.splice(index, 1) // remove entry at index

    console.log('agentApps', agentApps)

    const updatedPayload = {
      assistantId: params.assisstant_id,
      applications: agentApps,
    }

    const { response } = await AppService.app_agent.update({
      // use update, not delete
      payload: updatedPayload,
    })

    console.log('UpdateAgentRespon', response)

    if (response?.success) {
      setAgentApps(agentApps) // update state
      getAgentApps()
    }
  }
  const handleAppFunctionDelete = async (index) => {
    const { response } = await AppService.app_function.delete({
      query: `assistantId=${params.assisstant_id}&appId=${params.app_id}&functionIndex=${index}`,
      // use update, not delete
      // payload: payload,
    })

    console.log('app_functions', response)

    if (response?.success) {
      const updatedFunctions = [...appFunctions]
      updatedFunctions.splice(index, 1)
      setAppFunctions(updatedFunctions)
    }
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Agent ID', accessor: 'agent_id' },
        { Header: 'Name', accessor: 'name' },
        { Header: 'Description', accessor: 'description' },
        { Header: 'image', accessor: 'image' },
        { Header: 'location_id', accessor: 'location_id' },
        { Header: 'type', accessor: 'type' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: list?.map((data) => ({
        agent_id: data.agent_id,
        name: data.name,
        description: data.description,
        image: data.image,
        location_id: data.location_id,
        type: data.type,
        action: (
          <MDBox>
            <EditModal data={data} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="warning"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => navigate(`./${data._id}`)}
            >
              View
            </MDButton>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
    AppAgentData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'Description', accessor: 'description' },
        { Header: 'App ID', accessor: 'appId' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: agentApps?.map((data, index) => ({
        name: data.name,
        description: data.description.substring(0, 20) + '...',
        appId: data.appId,

        action: (
          <MDBox>
            <EditAgentAppModal
              data={data}
              handleRefresh={onLoad}
              index={index}
              assistantId={params?.assisstant_id}
            />
            <MDButton
              variant="contained"
              color="warning"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => navigate(`./${data?.appId}/functions`)}
            >
              View
            </MDButton>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleAppAgentDelete(index)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
    AppFunctionData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'Key', accessor: 'key' },
        // { Header: 'Active Status', accessor: 'isActive' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: appFunctions?.map((data, index) => ({
        name: data.name,
        key: data.key,
        // isActive: (
        //   <Switch
        //     checked={data.isActive}
        //     onChange={(e) => handleToggleActive(index, e.target.checked)}
        //     color="success"
        //   />
        // ),

        action: (
          <MDBox>
            <EditAgentFunctionModal
              data={data}
              handleRefresh={onLoad}
              index={index}
              assistantId={params?.assisstant_id}
              appId={params?.app_id}
            />

            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleAppFunctionDelete(index)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
